// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { JournalingBaseService } from './journaling-base.service';
import {
  JournalEntryModel,
  ToastEventModel,
  UnpinnedJournalModel,
} from '../../../models';
import { AppService } from '../app.service';
import { TranslateService } from '@ngx-translate/core';
import { QuadrantsBaseService } from './quadrants-base.service';
import { AppToastService } from '../app-toast.service';
import { Router } from '@angular/router';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class JournalingMockService extends JournalingBaseService {
  constructor(
    appService: AppService,
    quadrantsService: QuadrantsBaseService,
    router: Router,
    toastService: AppToastService,
    translateService: TranslateService
  ) {
    super(appService, translateService, quadrantsService, toastService, router);
  }

  getJournalEntriesByQuadrant(quadrantId: string): void {
    throw new Error('Method not implemented.');
  }

  getPinnedJournalEntryTextByStyleId(styleId: string): void {
    throw new Error('Method not implemented.');
  }

  getJournalEntryById(journalEntryId: string): void {
    throw new Error('Method not implemented.');
  }

  createJournalEntry(entry: JournalEntryModel): void {
    throw new Error('Method not implemented.');
  }

  pinJournalEntryText(entry: JournalEntryModel): void {
    throw new Error('Method not implemented.');
  }

  unpinJournalEntryText(entry: JournalEntryModel): void {
    throw new Error('Method not implemented.');
  }

  updateJournalEntryById(
    journalEntryId: string,
    entry: JournalEntryModel,
    canUndo = true
  ): void {
    throw new Error('Method not implemented.');
  }

  deleteJournalEntry(journalEntry: UnpinnedJournalModel): void {
    throw new Error('Method not implemented.');
  }

  undelete(): void {}

  revert(): void {}

  getAllJournalPins(): void {}
}
